import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import { Toast } from 'primereact/toast';
import { AlertCircle, CheckCircle2, XCircle } from 'lucide-react';



// CSS styles (inlined here)
const styleElement = document.createElement('style');
styleElement.innerHTML = `
  .toast-header {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .toast-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
`;
document.head.appendChild(styleElement);

const LoginToast = forwardRef((props, ref) => {
  const toast = useRef(null);

  useImperativeHandle(ref, () => ({
    showLoginToast() {
      toast.current.show({
        severity: 'warn',
        summary: (
          <div className="toast-header">
            <AlertCircle className="toast-icon" />
            <span>Login Required</span>
          </div>
        ),
        detail: 'Please login to continue',
        life: 3000,
      });
    },

    showSuccess(message = 'Operation successful') {
      toast.current.show({
        severity: 'success',
        summary: (
          <div className="toast-header">
            <CheckCircle2 className="toast-icon" />
            <span>Success</span>
          </div>
        ),
        detail: message,
        life: 3000,
      });
    },

    showError(message = 'Something went wrong') {
      toast.current.show({
        severity: 'error',
        summary: (
          <div className="toast-header">
            <XCircle className="toast-icon" />
            <span>Error</span>
          </div>
        ),
        detail: message,
        life: 3000,
      });
    },
  }));

  return <Toast ref={toast} />;
});

export default LoginToast;
